import { render, staticRenderFns } from "./PYXQHead.vue?vue&type=template&id=d7cfc0be&scoped=true"
import script from "./PYXQHead.vue?vue&type=script&lang=js"
export * from "./PYXQHead.vue?vue&type=script&lang=js"
import style0 from "./PYXQHead.vue?vue&type=style&index=0&id=d7cfc0be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7cfc0be",
  null
  
)

export default component.exports